import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Database } from '../../providers/database';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Translate } from '../../providers/translate';

@Component({
  selector: 'page-network-message',
  templateUrl: 'network-message.html',
})
export class NetworkMessage {

  obs: any;
	event: any;
	client: any;
  userAddressee: any;
	dataMessage: any = [];
  chatText: any;
  textTranslate: any;

  constructor(public navCtrl: NavController, public params: NavParams, public db: Database, translate: Translate, public eventProvider: EventData, public auth: AuthData) {
    translate.translateGroup(['Tmp'])
    .then(result => {
      this.textTranslate = result;
    });
		this.client = this.params.get('client');
		this.event = this.params.get('event');
		this.userAddressee = this.params.get('userAddressee');

    this.obs = this.eventProvider.getMessages(this.client, this.auth.getUser().uid, this.userAddressee.uid).subscribe((data) => {
      this.dataMessage = data;
    });
  }

  send() {
    let obj1 = {
      message: this.chatText,
      timestamp: new Date().getTime(),
      class: 'from-me'
    };
    let obj2 = {
      message: this.chatText,
      timestamp: new Date().getTime(),
      class: 'from-them'
    };

    this.db.pushData('/Clients/' + this.client.url + '/___NetworkingMessages/' + this.auth.getUser().uid + '/' + this.userAddressee.uid, obj1);

    this.db.pushData('/Clients/' + this.client.url + '/___NetworkingMessages/' + this.userAddressee.uid + '/' + this.auth.getUser().uid, obj2);

    this.chatText = "";
  }

  // Unsubsucribe observables on exit page
  ionViewWillUnload() {
    console.log('Se elimina el observable de chat', 'obs');
    if (this.obs) {
      this.obs.unsubscribe();
    }
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/network-message/network-message.ts